import {useParams} from "react-router";
import {BottomSheet} from "../bottom_sheet/BottomSheet";
import RestaurantHeader from "../restaurant/RestaurantHeader";
import Screen from '../screen';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store';
import Menu from '../menu/Menu';
import { MenuItemDetail } from '../menu_item/MenuItemDetail';
import { resetMenuItem } from '../../features/menuItem/menuItem.slice';
import StickyFooterQuid from './StickyFooterQuid';

const MenuQuid = () => {
    const dispatch = useDispatch();

    const { quid } = useParams<{quid:string}>();
    
    const menu = useSelector((state: RootState) => state.menu.menu);
    const menuItemSelected = useSelector((state: RootState) => state.menuItem.menuItemPath);

    const closeMenuItemDetail = () => {
        dispatch(resetMenuItem());
    }

   if(!!menu){
        return <Screen className="screen menu-quid-screen">
            <RestaurantHeader className='full-width block' showCart={false}/>
            <Menu onlyRead={false}></Menu>
            <StickyFooterQuid quid={quid}/>
            {!!menuItemSelected && 
                <BottomSheet className="bottom-sheet-detail" open={!!menuItemSelected} showClose={true} onClose={closeMenuItemDetail} radius={0}>
                    <MenuItemDetail onlyRead = {true} quid={quid} tableFinished={true}/>
                </BottomSheet>
            }
        </Screen>
    }
    return null;
};

export default MenuQuid;
